import {SxStyles} from "../../../../../../types";
import theme from "../../../../../../theme";
import {getResponsiveSize} from "../../../../../../utils";

export const AudioContentPanelStyle: SxStyles = {
    audioTabContainer: {
        display: "flex",
        justifyContent: "center",
        flexDirection: 'column',
        flexWrap: 'nowrap',
        alignItems: "center",

        '& .audio-container': {
            pt: `calc(${theme.palette.propVars?.index} * 1.5)`,
            width: getResponsiveSize(468),
            height: getResponsiveSize(258),

            '& iframe': {
                borderRadius: theme.palette.propVars?.borderRadius,
            }
        },

    },

}